/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { FC, ReactElement } from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

import metaImage from '../images/meta-image.png'
import favicon from '../images/favicon.ico'

interface ISEO {
  description?: string
  lang?: string
  meta?: any[]
  title: string
}

const SEO: FC<ISEO> = ({ lang }): ReactElement => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
    >
      <title>Meet Katalyst | A Workout Like Never Before</title>

      {/* Primary Meta Tags */}
      <meta
        name="title"
        content="Meet Katalyst | A Workout Like Never Before"
      />
      <meta
        name="description"
        content="A connected full-body EMS training system and on-demand workouts for everyone"
      />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://metatags.io/" />
      <meta
        property="og:title"
        content="Meet Katalyst | A Workout Like Never Before"
      />
      <meta
        property="og:description"
        content="A connected full-body EMS training system and on-demand workouts for everyone"
      />
      <meta property="og:image" content={metaImage} />

      {/* Twitter  */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://metatags.io/" />
      <meta
        property="twitter:title"
        content="Meet Katalyst | A Workout Like Never Before"
      />
      <meta
        property="twitter:description"
        content="A connected full-body EMS training system and on-demand workouts for everyone"
      />
      <meta property="twitter:image" content={metaImage} />

      <link
        rel="stylesheet"
        href="https://maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css"
      ></link>

      <link rel="icon" href={favicon} />

      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=UhMeme"
      />
      <script
        type="text/javascript"
        src="https://www.klaviyo.com/media/js/public/klaviyo_subscribe.js"
      ></script>
    </Helmet>
  )
}

export default SEO
